import JIcon from './JIcon';

export default JIcon;
